module.exports = __webpack_public_path__ + "img/icone-fleet-alert.49123962.svg";